import React from 'react';
import './DateRangePicker.css';

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  label?: string;
  minDate?: string;
  disabled?: boolean;
  error?: string;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  label,
  minDate,
  disabled = false,
  error,
}) => {
  return (
    <div className="date-range-picker">
      {label && <label className="date-range-label">{label}</label>}
      <div className="date-range-inputs">
        <div className="date-input-wrapper">
          <label htmlFor="start-date" className="date-input-label">
            From
          </label>
          <input
            id="start-date"
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            min={minDate}
            max={endDate || undefined}
            disabled={disabled}
            className={`date-input ${error ? 'date-input-error' : ''}`}
          />
        </div>
        <span className="date-range-separator">—</span>
        <div className="date-input-wrapper">
          <label htmlFor="end-date" className="date-input-label">
            To
          </label>
          <input
            id="end-date"
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            min={startDate || minDate}
            disabled={disabled}
            className={`date-input ${error ? 'date-input-error' : ''}`}
          />
        </div>
      </div>
      {error && <p className="date-range-error">{error}</p>}
    </div>
  );
};

export default DateRangePicker;
